const routes = [
  {
    path: '/brushteeth/index',
    name: 'brushteeth-index',
    component: () => import('@/views/brush-teeth/BrushTeethPage.vue'),
    meta: {
      title: '每日刷牙打卡挑战',
    },
  },
  {
    path: '/brushteeth/rule',
    name: 'brushteeth-rule',
    component: () => import('@/views/brush-teeth/RulePage.vue'),
    meta: {
      title: '奖励规则',
    },
  },
  {
    path: '/brushteeth/poster',
    name: 'brushteeth-poster',
    component: () => import('@/views/brush-teeth/PosterPage.vue'),
    meta: {
      title: '打卡海报',
    },
  },
  {
    path: '/brushteeth/reward',
    name: 'brushteeth-reward',
    component: () => import('@/views/brush-teeth/RewardPage.vue'),
    meta: {
      title: '领奖记录',
    },
  },
];
export default routes;
